import React from 'react';
import FetchNotificationConnectorRemoteConfig from '../ApolloConnectors/FirebaseNotifications/FetchNotificationConnectorRemoteConfig';
import { compareVersions } from 'compare-versions';
import useAppContext from '../AppContext/useAppContext';

const ForceUpdate: React.FC = () => {
  const {
    consts: { APP_VERSION },
    functions: { fetchRemoteConfigFields },
  } = useAppContext();

  return (
    <FetchNotificationConnectorRemoteConfig
      fetchRemoteConfigFields={fetchRemoteConfigFields}
      remoteConfigFields={['frontend_app_version']}
    >
      {({ loading, notificationData }) => {
        if (!loading) {
          const remoteAppVersion = notificationData?.frontend_app_version as string;
          const currentVersion = APP_VERSION as string;

          if (currentVersion && remoteAppVersion) {
            if (compareVersions(currentVersion, remoteAppVersion) < 0) {
              localStorage.removeItem('apollo-cache-persist');
              window.location.reload();
            }
          }
        }
        // eslint-disable-next-line react/jsx-no-useless-fragment
        return <></>;
      }}
    </FetchNotificationConnectorRemoteConfig>
  );
};

export default ForceUpdate;
